import { create } from "zustand";
import { persist } from "zustand/middleware";

// Define the shop store type
export interface ImpersonationState {
    impersonationEmail: string | null;
    setImpersonationEmail: (email: string) => void;
    resetImpersonation: () => void;
}

// Create a persisted Zustand store
export const useImpersonationStore = create<ImpersonationState>()(
    persist(
        (set) => ({
            impersonationEmail: null,
            setImpersonationEmail: (email) => set({ impersonationEmail: email }),
            resetImpersonation: () => set({ impersonationEmail: null }),
        }),
        {
            name: "impersonation-storage", // unique name for localStorage key
        }
    )
); 